import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  heading: 'Unable to load your balance',
  description:
    'Something went wrong when loading your total available balance. Please try again.',
})
